export default __webpack_public_path__ + "static/media/paygo-1.a542c3a2.png";